// src/Components/BusList.jsx
import React from 'react';
import styles from '../Pages/BusManagement.module.css';

const BusList = React.memo(({ buses, driverOptions, busTypeOptions, onEdit, onDelete }) => {

  if (!buses || buses.length === 0) {
    return (
      <p className={styles.emptyMessage}>No hay buses registrados.</p>
    );
  }

  return (
    <>
      <h3 className={styles.listTitle}>Lista de Buses</h3>

      <div className={styles.tableContainer}>
        <table className={styles.busTable}>
          <thead>
            <tr>
              <th>Placa</th>
              <th>Tipo de Bus</th>
              <th>Conductor</th>
              <th>Estado</th>
              <th className={styles.actionsHeader}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {buses.map(bus => {
              // Encontrar el nombre del conductor
              const driverId = bus.ID_driver || bus.driver_id;
              const conductorLabel = driverId
                ? (driverOptions?.find(o => o.value === driverId)?.label || 'Sin asignar')
                : 'Sin asignar';

              // Encontrar el tipo de bus
              const busTypeId = bus.ID_type_bus || bus.bus_type_id;
              const busTypeLabel = busTypeId
                ? (busTypeOptions?.find(o => o.value === busTypeId)?.label || '—')
                : '—';

              // Traducir estado
              const statusMap = {
                'available': 'Disponible',
                'maintenance': 'Mantenimiento',
                'outservice': 'Fuera de Servicio'
              };
              const statusLabel = statusMap[bus.Status || bus.status] || bus.Status || bus.status;

              return (
                <tr key={bus.ID || bus.id} className={styles.busTableRow}>
                  <td>
                    <span className={styles.busPlate}>{bus.Plate || bus.plate}</span>
                  </td>
                  <td>{busTypeLabel}</td>
                  <td>
                    <span className={styles.busDriver}>{conductorLabel}</span>
                  </td>
                  <td>{statusLabel}</td>
                  <td className={styles.actionsCell}>
                    <button
                      onClick={() => onEdit(bus)}
                      className={styles.buttonEdit}
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => onDelete(bus.ID || bus.id)}
                      className={styles.buttonDelete}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
});

export default BusList;